/**
 * Shared Header Component
 * Consistent header across all CueSesh pages
 */

import React from 'react';
import AnimatedCueSeshLogo from './AnimatedCueSeshLogo';
import { trackAppStoreClick, appStoreUrl } from '../utils/analytics';
import './Header.css';

const Header = () => {
  return (
    <header className="cuesesh-header">
      <a href="/" className="cuesesh-header-logo-container">
        <AnimatedCueSeshLogo
          className="cuesesh-logo"
          isTimerActive={false}
        />
        <span className="cuesesh-logo-text">CueSesh</span>
      </a>

      {/* Anchor nav — /#id form because this header is shared beyond Landing.
          FAQ item lands with its section (landing-rebuild Phase 5); no links to
          targets that don't exist yet. Hidden on small screens. */}
      <nav className="cuesesh-header-nav" aria-label="Primary">
        <a href="/#how-it-works" className="cuesesh-header-nav-link">How it works</a>
        <a href="/#faq" className="cuesesh-header-nav-link">FAQ</a>
      </nav>

      {/* Persistent download CTA — a text pill, so the hero's App Store badge is the
          only badge above the fold (two badges in 500px competed with each other).
          Same destination and the same `header` conversion event as before. */}
      <a
        href={appStoreUrl('header')}
        target="_blank"
        rel="noopener noreferrer"
        className="cuesesh-header-cta"
        aria-label="Get CueSesh on the App Store"
        onClick={() => trackAppStoreClick('header')}
      >
        Get CueSesh
      </a>
    </header>
  );
};

export default Header;
